import { ReactComponent as SearchSVG } from '@assets/SVGs/PresenteeismTable/SearchSVG.svg';
import Image from '@components/General/Image';
import { TableCell } from '@mui/material';
import React, { useEffect } from 'react';
import styles from '@styles/screens/StartDemoScreen.module.css'
import { ReactComponent as QontactTextSVG } from '@assets/SVGs/GeneralUse/Qontact.svg';
import { CardContainer, HorizontalContainer, HorizontalSpacer, VerticalContainer } from "@components/General/Containers"
import designSystem from "@styles/designSystem"
import { H2Title, Subtitle } from '@components/General/Titles';
import Table from '@components/General/Table';
import { useCheckinsViewModel, ViewState } from '../view-models/CheckinsScreenViewModel';
import { TextInput } from '@components/General/TextInput';
import { GhostButton, NormalButton, RefreshButton } from '@components/General/Button';
import { Modal } from '@components/Messages/Modal';
import { usePopup } from '@contexts/popupContext';
import { PromotionalScreen } from '../demo/PromotionalScreen';
import { ErrorText, SmallText, Text } from '@components/General/Texts';
import { Logger } from '@utils/Logger';
import { isMobile } from 'react-device-detect';
import { Application } from '@core/Application';
import { ToastManager } from '@components/Messages/ToastManager';


function rowTemplate(_index, row) {

    const getColor = (color) => {
        switch (color) {
            case 'green':
                return designSystem.colorPresenteeismGreen
            case 'red':
                return designSystem.colorPresenteeismRed
            case 'yellow':
                return designSystem.colorPresenteeismYellow
            default:
                return designSystem.colorPresenteeismDefault
        }
    }

    const processName = (name) => {
        const words = name?.split(' ')
        if (!words) {
            return name
        }
        const processedWords = words.map(word => {
            const firstLetter = word.charAt(0).toUpperCase()
            const restOfWord = word.slice(1).toLowerCase()
            return firstLetter + restOfWord
        })
        return processedWords.join(' ')
    }

    const nameParts = row.colaborador?.split(' ') || []
    const firstName = nameParts.slice(0, -1).join(' ')
    const lastName = nameParts[nameParts.length - 1]
    Logger.logObject("row", row)
    return (
        <CardContainer padding={designSystem.paddingMd}>
            <HorizontalContainer>
                <VerticalContainer 
                    gap={designSystem.paddingZero}
                    width={'20%'}
                    maxWidth={'200px'}
                >
                    <SmallText text={firstName}/>
                    <SmallText text={'**'+lastName+'**'} markdown={true}/>
                </VerticalContainer>

                <VerticalContainer 
                    alignment={'start'}
                    gap={designSystem.paddingZero}
                    width={'50%'}
                >
                    <HorizontalContainer>
                        <SmallText text={row.date?.substring(0, 5)}/>
                        <SmallText text={row.checkinTime}/>
                        <SmallText text={row.checkoutTime}/>
                    </HorizontalContainer>
                    <HorizontalContainer>
                        <SmallText text={row.buildingName}/>
                    </HorizontalContainer>
                </VerticalContainer>

                <VerticalContainer
                    gap={designSystem.paddingZero}
                    width={'30%'}
                    alignment={'end'}
                >
                    <SmallText 
                        text={row.analysis?.subtext}
                        alignment={'end'}
                    />
                </VerticalContainer>
            </HorizontalContainer>
        </CardContainer>
    )
}

export const MobileCheckinsScreen: React.FC = () => {

    const {
        visiblePresenteeismRecords,
        viewState,
        searchText,
        placeholderText,
        qpID,
        serviceError,
        setSearchText,
        setPlaceholderText,
        reloadData,
        search,
        viewDidAppear,
        analytics,
    } = useCheckinsViewModel()

    // viewDidAppear - runs only once when component first mounts
    useEffect(() => {
        // Call your hook or function here
        viewDidAppear()
    }, []) // Empty dependency array ensures this runs only once
    
    const { showPopup, hidePopup } = usePopup()

    const handleOpenModal = () => {
        console.log('handleOpenModal called')
        analytics.trackPromotionalModalButtonTapped()
        showPopup(() => (
            <Modal 
                isOpen={true}
                onClose={hidePopup}
                width={'600px'}
                height={'100%'}
                maxHeight={'400px'}
            >
                <PromotionalScreen
                    onClick={() => {
                        analytics.trackWhatsAppButtonTapped()
                    }}
                />
            </Modal>
        ), true)
    }

    return (
        <VerticalContainer
            gap={designSystem.gapNone}
            height={'100%'}
        >
            <VerticalContainer 
                backgroundColor={designSystem.colorMainAction} 
                height={'80px'}
            >
                <div style={{
                    width: '200px',
                    height: '80px',
                    alignContent: 'start',
                    paddingLeft: designSystem.paddingLg,
                    zIndex: '-moz-initial',
                }}>
                    <a 
                        href="https://qontact.com.ar" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={{
                            display: 'block',
                            width: '100%',
                            height: '100%',
                            cursor: 'pointer',
                            marginLeft: '-12px'
                        }}
                    >
                        <QontactTextSVG />
                    </a>
                </div>
            </VerticalContainer>
            <VerticalContainer
                backgroundColor={designSystem.colorBackgroundGray3}
                width={'100%'}
                height={'100%'}
                maxWidth={'100%'}
                paddingBottom={designSystem.paddingMd}
                // alignment={'start'}
                paddingLeft={designSystem.paddingSm}
                paddingRight={designSystem.paddingSm}
            >
                <VerticalContainer gap={designSystem.paddingZero}>
                    <H2Title text={"Fichadas Hoy".localized()} />
                    <Subtitle text={"Presentismo de todos los colaboradores".localized()} />
                </VerticalContainer>
                <HorizontalContainer gap={designSystem.gapMd}>
                    <TextInput
                        label=""
                        placeholder=""
                        onChange={(e) => { search(e) }}
                        onEnterPress={() => { }}
                        value={searchText}
                        icon={<SearchSVG style={{ width: designSystem.sizeIconWidth, height: designSystem.sizeIconHeight }} />}
                    />
                    <RefreshButton
                        text=""
                        onClick={reloadData}
                    />
                </HorizontalContainer>
                { serviceError && 
                    <ErrorText text={serviceError}/>
                }
                <VerticalContainer height={'100%'}>
                    { viewState == ViewState.loading &&
                        <VerticalContainer 
                            height={'100%'}
                            alignment={'center'}
                        >
                            <SmallText text={"Cargando fichadas...".localized()} />
                        </VerticalContainer>
                    }
                    { viewState != ViewState.loading &&
                        visiblePresenteeismRecords.map((row, index) => {
                            return (rowTemplate(index, row))
                        })                        
                    }
                </VerticalContainer>
                <VerticalContainer alignment={'center'}>
                    <NormalButton 
                        text={'Comienza tu prueba gratis!'.localized()}
                        width={"100%"}
                        onClick={() => {
                            handleOpenModal()
                        }} 
                    />
                </VerticalContainer>
            </VerticalContainer>
        </VerticalContainer>
    )
}
